import { Component, Vue } from "vue-property-decorator";
import VueStore from "@/store/VueStore";
import axios from "axios";
import SignalMappingComponent from "@/components/signalMapping/SignalMapping.vue";
import {
  MstGraphTitlesType,
  MstMappingType,
  SensorStateType,
  SensorAreaSizeItemsType
} from "@/types/types";
import MstGraphService from "@/services/mst_graph_service";
import MstMappingService from "@/services/mst_mapping_service";
import { RequestParamsMaker } from "@/views/indexSignalMapping/scripts/make_request_params";
import { setBackGroundImage, getBase64 } from "@/views/indexSignalMapping/scripts/background_image";

@Component({
  components: {
    SignalMappingComponent
  }
})
export default class IndexSignalMapping extends Vue {
  // マスター情報
  public mstGraphs: MstGraphTitlesType[] = [];
  public targetMstGraphIndex: number = null;
  public mstMapping: MstMappingType = null;
  public mstMappings: MstMappingType[] = [];
  public selectMstMappingIndex: number = null;
  public selectMstMapping: MstMappingType = null;
  public userID: string = "";
  public signallampIDs: string[] = [];
  public signallampID: number = null;
  // 状態保存
  public editSensorAreaFlag: boolean = false;
  // 設定
  public backgroundImage: string = null;
  public offIconClass: boolean = true;
  public signalAreaOverlay: boolean = false;
  public sensorAreaSize: string = "midium";
  public sensorAreaSizeItems: SensorAreaSizeItemsType[] = [
    {
      label: "小",
      value: "small"
    },
    {
      label: "中",
      value: "midium"
    },
    {
      label: "大",
      value: "large"
    }
  ];

  public async created() {
    this.$parent.$children[0].$data.headerElement = true;
    this.userID = VueStore.state.userName;
    this.signallampIDs = JSON.parse(localStorage.getItem("graphSettings")).signallampIDs;
    this.mstGraphs = await MstGraphService.queryAll(this.userID); // TODO
    // マッピングマスターの取得
    this.mstMappings = await MstMappingService.queryAll(this.userID);
    setBackGroundImage(this);
    this.checkRemainderSignallampId();
  }

  /**
   * アップロードされた画像をS3に保存
   * @param image
   */
  public async uploadImage(image: any) {
    try {
      const userID = this.userID;
      const self = this;
      // Bese64で画像ファイルをバイナリにしてAPIを叩く
      getBase64(image.file).then(function(value) {
        const reqParams = RequestParamsMaker.makeUploadImageParams(userID, value);
        axios(reqParams);
        self.backgroundImage = String(value);
      });
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * コンポーネント設定を確認し、差異があればマッピング側のコンポーネントの追加・削除を行う
   */
  public async checkRemainderSignallampId() {
    const mappingSignallampIds = [];
    let signallampIdResult = null;
    let integrityResult = null;
    for (const keyMapping in this.mstMappings) {
      mappingSignallampIds.push(this.mstMappings[keyMapping].mst_signallamp_id);
      signallampIdResult = this.signallampIDs.indexOf(this.mstMappings[keyMapping].mst_signallamp_id);
      if (signallampIdResult < 0) {
        // もしsignallampIDの中にないマッピングがあれば、パネルを削除する
        await this.deleteMstMapping(this.mstMappings[keyMapping]);
      }
    }
    for (const key in this.signallampIDs) {
      integrityResult = mappingSignallampIds.indexOf(this.signallampIDs[key]);
      if (integrityResult < 0) {
        // もしマッピングの中にないsignallampIDがあれば、パネルを追加する
        await this.addMstMapping(this.signallampIDs[key]);
      }
    }
  }

  /**
   * ドラッグ可否の切り替え
   */
  public changeEditFlag() {
    this.editSensorAreaFlag = !this.editSensorAreaFlag;
    this.offIconClass = !this.offIconClass;
  }

  /**
   * mappingMaster 選択時処理
   */
  public changeSelectMstMapping() {
    this.selectMstMapping = this.mstMappings[this.selectMstMappingIndex];
    this.mstGraphs.map((item, index: number) => {
      if (item.graph_id === this.selectMstMapping.mst_graph_id) {
        this.targetMstGraphIndex = Number(index);
      }
    });
    this.sensorAreaSize = this.judgeSensorAreaSize((this.selectMstMapping.sensor_state as SensorStateType).height);
  }

  /**
   * 設置画面非表示
   */
  public hiddenSettingModal() {
    this.signalAreaOverlay = false;
  }

  /**
   * マスター登録
   */
  public async addMstMapping(signallampID: string) {
    try {
      this.mstMapping = this.initMstMapping(signallampID);
      await MstMappingService.create(this.mstMapping);
      this.mstMappings.push(this.mstMapping);
    } catch (err) {
      console.error(err);
    }
  }
  /**
   * マスター更新
   */
  public async updateMstMapping() {
    try {
      this.setMstMapping();
      await MstMappingService.update(this.selectMstMapping);
      this.mstMappings[this.selectMstMappingIndex] = this.selectMstMapping;
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * マスター削除
   */
  public async deleteMstMapping(deleteTargetMstMapping: any) {
    try {
      await MstMappingService.delete(deleteTargetMstMapping.user_id, deleteTargetMstMapping.mapping_id);
      this.mstMappings = await MstMappingService.queryAll(deleteTargetMstMapping.user_id);
      this.hiddenSettingModal();
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * mapping_idの生成
   */
  public setMappingID(): number {
    if (this.mstMappings.length > 0) {
      const latestMstMapping = this.mstMappings[this.mstMappings.length - 1];
      return latestMstMapping.mapping_id + 1;
    } else {
      return 0;
    }
  }

  /**
   * センサーのサイズ設定
   * @param side
   */
  public setSensorAreaSize(side: string): number {
    switch (this.sensorAreaSize) {
      case "small":
        if (side === "height") {
          return 100;
        } else {
          return 120;
        }
      case "large":
        if (side === "height") {
          return 200;
        } else {
          return 180;
        }
      default:
        if (side === "height") {
          return 207;
        } else {
          return 315;
        }
    }
  }

  public judgeSensorAreaSize(value: number): string {
    switch (value) {
      case 100:
        return "small";
      case 200:
        return "large";
      default:
        return "midium";
    }
  }

  /**
   * mappingMaster 初期設定生成
   */
  public initMstMapping(signallampID: string): MstMappingType {
    // TODO: appsyncをdisplayNameとtargetAttributeとselectDeviceIdを削除するように更新する
    return {
      user_id: VueStore.state.userName,
      mapping_id: this.setMappingID(),
      mst_graph_id: 1,
      sensor_state: {
        displayName: "--",
        targetAttribute: "--",
        xPosition: 0,
        yPosition: 0,
        width: this.setSensorAreaSize("width"),
        height: this.setSensorAreaSize("height")
      },
      mst_signallamp_id: Number(signallampID),
      select_device_id: "--",
    };
  }

  /**
   * mappingMaster 更新生成
   */
  public setMstMapping() {
    const newMstMapping: MstMappingType = this.selectMstMapping;
    newMstMapping.mst_graph_id = this.mstGraphs[this.targetMstGraphIndex].graph_id;
    const sensorState: SensorStateType = newMstMapping.sensor_state as SensorStateType;
    sensorState.width = this.setSensorAreaSize("width");
    sensorState.height = this.setSensorAreaSize("height");
    newMstMapping.sensor_state = sensorState;
    this.selectMstMapping = newMstMapping;
  }
}
